var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      _c("h5", { staticClass: "mb-3" }, [_vm._v("Documentação Jurídica")]),
      _c(
        "b-alert",
        { staticClass: "mb-4", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("h6", { staticClass: "alert-heading" }, [
              _c("i", { staticClass: "feather icon-info mr-1" }),
              _vm._v(" Documentos Necessários ")
            ]),
            _c("hr"),
            _c("p", { staticClass: "mb-2" }, [
              _c("strong", [_vm._v("• Formato aceito:")]),
              _vm._v(" PDF (máximo 5MB por arquivo) ")
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _c("strong", [_vm._v("• Qualidade:")]),
              _vm._v(" Documentos devem estar legíveis e completos ")
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _c("strong", [
                _vm._v(
                  "• Campos indicados como obrigatórios devem ser preenchidos"
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Estatuto/Ato Constitutivo",
                    "label-class": "required",
                    "label-for": "statute"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "statute",
                      value: _vm.formData.statute
                        ? _vm.formData.statute.file
                        : null,
                      placeholder: "Escolha o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("statute"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("statute", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.statute
                    ? [
                        _vm.formData.statute.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.statute.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Estatuto é obrigatório ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Ata de Eleição de Dirigentes",
                    "label-class": "required",
                    "label-for": "election_minutes"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "election_minutes",
                      value: _vm.formData.election_minutes
                        ? _vm.formData.election_minutes.file
                        : null,
                      placeholder: "Escolha o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("election_minutes"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("election_minutes", $event)
                      }
                    }
                  }),
                  _vm.formData && _vm.formData.election_minutes
                    ? [
                        _vm.formData.election_minutes.uploaded
                          ? _c(
                              "small",
                              { staticClass: "form-text text-success" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-check-circle mr-1"
                                }),
                                _vm._v(" Arquivo enviado com sucesso ")
                              ]
                            )
                          : _vm.formData.election_minutes.file
                          ? _c(
                              "small",
                              { staticClass: "form-text text-warning" },
                              [
                                _c("i", {
                                  staticClass: "feather icon-upload mr-1"
                                }),
                                _vm._v(" Enviando arquivo... ")
                              ]
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Ata de Eleição é obrigatória ")
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Certificado CNPJ",
                    "label-class": "required",
                    "label-for": "cnpjCertificate"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "cnpjCertificate",
                      value: _vm.formData.cnpj_certificate
                        ? _vm.formData.cnpj_certificate.file
                        : null,
                      placeholder: "Escolha o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("cnpj_certificate"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("cnpj_certificate", $event)
                      }
                    }
                  }),
                  _vm.formData.cnpj_certificate &&
                  _vm.isFileUploaded("cnpj_certificate")
                    ? _c("small", { staticClass: "form-text text-success" }, [
                        _c("i", {
                          staticClass: "feather icon-check-circle mr-1"
                        }),
                        _vm._v(
                          " Arquivo enviado: " +
                            _vm._s(_vm.getFileName("cnpj_certificate")) +
                            " "
                        )
                      ])
                    : _vm.formData.cnpj_certificate &&
                      !_vm.isFileUploaded("cnpj_certificate")
                    ? _c("small", { staticClass: "form-text text-warning" }, [
                        _c("i", { staticClass: "feather icon-upload mr-1" }),
                        _vm._v(
                          " Enviando arquivo: " +
                            _vm._s(_vm.getFileName("cnpj_certificate")) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Certificado CNPJ é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label:
                      "Identificação dos integrantes do corpo dirigente de cada instituição",
                    "label-class": "required",
                    "label-for": "identification_members"
                  }
                },
                [
                  _c("b-form-file", {
                    attrs: {
                      id: "identificationMembers",
                      value: _vm.formData.identification_members
                        ? _vm.formData.identification_members.file
                        : null,
                      placeholder: "Escolha o arquivo ou arraste aqui...",
                      "drop-placeholder": "Solte o arquivo aqui...",
                      accept: "application/pdf",
                      state: _vm.getFieldState("identification_members"),
                      disabled: _vm.disabled
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateField("identification_members", $event)
                      }
                    }
                  }),
                  _vm.formData.identification_members &&
                  _vm.isFileUploaded("identification_members")
                    ? _c("small", { staticClass: "form-text text-success" }, [
                        _c("i", {
                          staticClass: "feather icon-check-circle mr-1"
                        }),
                        _vm._v(
                          " Arquivo enviado: " +
                            _vm._s(_vm.getFileName("identification_members")) +
                            " "
                        )
                      ])
                    : _vm.formData.identification_members &&
                      !_vm.isFileUploaded("identification_members")
                    ? _c("small", { staticClass: "form-text text-warning" }, [
                        _c("i", { staticClass: "feather icon-upload mr-1" }),
                        _vm._v(
                          " Enviando arquivo: " +
                            _vm._s(_vm.getFileName("identification_members")) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _c("b-form-invalid-feedback", [
                    _vm._v(" Certificado digital é obrigatório ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.hasUploadedFiles
        ? _c(
            "div",
            { staticClass: "uploaded-files mt-4" },
            [
              _vm._m(0),
              _c(
                "b-card",
                [
                  _c(
                    "b-list-group",
                    _vm._l(_vm.uploadedFiles, function(file, key) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: key,
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("div", [
                            _c("i", {
                              staticClass:
                                "feather icon-file-text text-danger mr-2"
                            }),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getDocumentTitle(key)))
                            ]),
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm.getJuridicalDocumentUrl(
                                _vm.uploadedFiles[key]
                              )
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "mr-1 no-print download-link text-primary",
                                      attrs: {
                                        href: _vm.getJuridicalDocumentUrl(
                                          _vm.uploadedFiles[key]
                                        ),
                                        target: "_blank",
                                        title: "Baixar arquivo"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "feather icon-download"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" " + _vm._s(_vm.getFileName(key)) + " "),
                              _c("small", { staticClass: "ml-2" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      _vm.formatFileSize(_vm.getFileSize(key))
                                    ) +
                                    ")"
                                )
                              ]),
                              _c("small", { staticClass: "ml-2 text-muted" }, [
                                _vm._v(
                                  "[" +
                                    _vm._s(
                                      _vm.getFileExtension(_vm.getFileName(key))
                                    ) +
                                    "]"
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", { staticClass: "text-muted mb-3" }, [
      _c("i", { staticClass: "feather icon-check-circle mr-1" }),
      _vm._v(" Arquivos Carregados ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }